import { render, staticRenderFns } from "./MlLoading.vue?vue&type=template&id=77bc6320&scoped=true&"
import script from "./MlLoading.vue?vue&type=script&lang=js&"
export * from "./MlLoading.vue?vue&type=script&lang=js&"
import style0 from "./MlLoading.vue?vue&type=style&index=0&id=77bc6320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bc6320",
  null
  
)

export default component.exports